import React from 'react';
import cn from 'classnames';
import Style from './style';

const NoFission = ({ intl, commissionValues }) => {
  const [firstRatio = 0, secondRatio = 0] = commissionValues?.map((item) => item / 10) || [];
  return (
    <Style>
      <div className='no-fission-image-wrapper'>
        <img
          src='https://img01.yzcdn.cn/upload_files/2021/09/28/FkocbhWEqPS5gcqMUG0KALMsbLbe.png'
          alt='activity flow'
          className='fission-image'
        />
        <span className='you'>{intl.formatMessage({ id: 'you', defaultMessage: '你' })}</span>
        <span className='buddy_1'>{intl.formatMessage({ id: 'buddy_1', defaultMessage: '好友1' })}</span>
        <span className={cn('circle-block', 'first-percent', { oval: firstRatio > 9 })}>{firstRatio + '%'}</span>
      </div>
    </Style>
  );
};

export default NoFission;
